import React, {useState} from 'react';
import {Checkbox, DeprecatedCreativeModal as Modal, FlexRow, Label, Text, TextField} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import type {SaveReportAsInput} from '../../../../../mutations/ts/reporting/__generated__/SaveReportAsMutation.graphql';

type SaveReportAsModalProps = {
	saveReportAs: (closeModal: () => void, report: SaveReportAsInput) => void;
	report: SaveReportAsInput;
	closeModal: () => void;
};

const SaveReportAsModal = ({saveReportAs, report, closeModal}: SaveReportAsModalProps): React.JSX.Element => {
	const intl = useIntl();

	const initialName = report.name + ', Duplicate';

	const [name, setName] = useState(initialName);
	const [privateAccess, setPrivateAccess] = useState(report.privateAccess);

	return (
		<Modal
			title={intl.formatMessage({id: 'saved_report.new_report'})}
			onCreateHandler={() => saveReportAs(closeModal, {...report, name, privateAccess})}
			creativeButtonText={intl.formatMessage({id: 'saved_report.save_as'})}
			size="m"
			closeModal={closeModal}
			replicateDesignSystem
		>
			<TextField label="Report Name" value={name} onValueChange={setName} data-cy="report-name-input" />
			<Label>{intl.formatMessage({id: 'report.share-company-label'})}</Label>
			<FlexRow>
				<Checkbox checked={!privateAccess} onChange={value => setPrivateAccess(!value)}></Checkbox>
				<Text>{intl.formatMessage({id: 'report.private_access.description'})}</Text>
			</FlexRow>
		</Modal>
	);
};

export default SaveReportAsModal;
